import { TransportScope } from "src/tmc-yard/common/model/transport.model";
import { TransportDetails, TransportType } from "src/tmc-yard/components/transport-details/transport-details-model";
import { Transport as TransportNeu } from "src/tmc-yard/common/model/transport.model"

export enum TransportStatus {
  PLANNED = 'PLANNED',
  IN_THE_INFLOW = 'IN_THE_INFLOW',
  CREATED = 'CREATED',
  REGISTERED = 'REGISTERED',
  WAITING = 'WAITING',
  RETRIEVED = 'RETRIEVED',
  LOADING_COMPLETE = 'LOADING_COMPLETE',
  COMPLETE = 'COMPLETE',
  FINISHED = 'FINISHED',
  CANCELLED = 'CANCELLED',
  CANCELED_EXTERNALLY = 'CANCELED_EXTERNALLY',
  FINISHED_CANCELLED = 'FINISHED_CANCELLED',
  PAUSED = 'PAUSED',
  NOT_APPEARED = 'NOT_APPEARED',
  NONE = 'NONE'
}

export enum PendingTaskState {
  NONE = 'NONE', ANY = 'ANY', IMPORTANT = 'IMPORTANT'
}

export enum TransportManagementLevel {
  LIFECYCLE = 'LIFECYCLE', LOCATION = 'LOCATION'
}

export enum TransportRelevance {
  NOT_RELEVANT = 'NOT_RELEVANT', CURRENT_RELEVANT = 'CURRENT_RELEVANT', ARCHIVED = 'ARCHIVED'
}


export class TransportIdentity {
  customFilterId: number;
}

export class Transport {
  id: number;
  name: string;
  carrier: string;
  supplier: string;
  numberPlate: string;
  reference: string;
  receiver: string;
  start: string;
  startSortValue: number;
  end: string;
  important: boolean;
  urgent: boolean;
  status: TransportStatus;
  currentStation: string;
  nextStation: string;
  waitingTime: number;
  activeMessagingChannels: string;
  messagingReference: string;
  highlightingStyle: string;
  processingTime: string;
  registrationCode: string;
  processingTimeStyle: string;
  searchText: string;
  identifier: string;
  transportScope: TransportScope;
  options: string;
  cargo: string;
  planningDate: string;
  planningDateSortValue: number;
  messagingResources: string;
  string1: string;
  string2: string;
  umbrueckung: boolean;
  currentStationId: number;
  wasRegistered: boolean;
  internal: boolean;
  staysOnYardAsVehicle: boolean;
  transportType: TransportType;
  currentPositionIfsStatus1: string;
  currentPositionIfsStatus2: string;

  trailerIdentifier: string;
  loadingTypeDictionaryKey: string;
  vehicleTypeDictionaryKey: string;

  currentPositionStatusDictionaryKey: string;
  currentPositionStart: string;
  currentPositionStatusStart: string;
  currentPositionDuration: number;
  currentPositionStatusDuration: number;
  currentPositionStartSortValue: number;
  currentPositionStatusStartSortValue: number;

  currentPositionCargo: string;
  currentPositionHint: string;

  processingTimeCurrentProcessing: string;

  beginReal: string;
  beginRealSortValue: number;
  dangerousGoods: false;
  transportName: string;

  transportDetails: TransportNeu;

  currentRoutingPositionOptionValues: string;
  nextProcessingPositionOptionValues: string;

  useGlobalConnect = false;
  useSms = false;

  usePager = false;

  intermitted = false;

  actionRequired = false;

  processingDurationCritical = false;

  pendingTaskState: PendingTaskState;

  managementLevel: TransportManagementLevel;

  relevance: TransportRelevance;

  transportOptionParameterValues: string;

  hasMovementOrder: boolean;

  constructor(transport: Partial<Transport>) {

    if (transport == null) {
      return;
    }

    this.id = transport.id;
    this.name = transport.name;
    this.carrier = transport.carrier;
    this.supplier = transport.supplier;
    this.numberPlate = transport.numberPlate;
    this.reference = transport.reference;
    this.receiver = transport.receiver;
    this.start = transport.start;
    this.startSortValue = transport.startSortValue;
    this.end = transport.end;
    this.important = transport.important;
    this.urgent = transport.urgent;
    this.status = transport.status;
    this.currentStation = transport.currentStation;
    this.nextStation = transport.nextStation;
    this.waitingTime = transport.waitingTime;
    this.activeMessagingChannels = transport.activeMessagingChannels;
    this.messagingReference = transport.messagingReference;
    this.highlightingStyle = transport.highlightingStyle;
    this.processingTime = transport.processingTime;
    this.registrationCode = transport.registrationCode;
    this.processingTimeStyle = transport.processingTimeStyle;
    this.searchText = transport.searchText;
    this.identifier = transport.identifier;
    this.transportScope = transport.transportScope;
    this.options = transport.options;
    this.cargo = transport.cargo;
    this.planningDate = transport.planningDate;
    this.planningDateSortValue = transport.planningDateSortValue;
    this.messagingResources = transport.messagingResources;
    this.string1 = transport.string1;
    this.string2 = transport.string2;
    this.umbrueckung = transport.umbrueckung;
    this.currentStationId = transport.currentStationId;
    this.wasRegistered = transport.wasRegistered;
    this.internal = transport.internal;
    this.staysOnYardAsVehicle = transport.staysOnYardAsVehicle;
    this.transportType = transport.transportType;
    this.currentPositionStatusDictionaryKey = transport.currentPositionStatusDictionaryKey;
    this.currentPositionStart = transport.currentPositionStart;
    this.currentPositionStatusStart = transport.currentPositionStatusStart;
    this.currentPositionDuration = transport.currentPositionDuration;
    this.currentPositionStatusDuration = transport.currentPositionStatusDuration;
    this.currentPositionStartSortValue = transport.currentPositionStartSortValue;
    this.currentPositionStatusStartSortValue = transport.currentPositionStatusStartSortValue;
    this.currentPositionCargo = transport.currentPositionCargo;
    this.currentPositionHint = transport.currentPositionHint;
    this.processingTimeCurrentProcessing = transport.processingTimeCurrentProcessing;
    this.beginReal = transport.beginReal;
    this.beginRealSortValue = transport.beginRealSortValue;
    this.dangerousGoods = transport.dangerousGoods;
    this.transportName = transport.transportName;
    this.currentRoutingPositionOptionValues = transport.currentRoutingPositionOptionValues;
    this.nextProcessingPositionOptionValues = transport.nextProcessingPositionOptionValues;
    this.intermitted = transport.intermitted;
    this.actionRequired = transport.actionRequired;
    this.processingDurationCritical = transport.processingDurationCritical;
    this.pendingTaskState = transport.pendingTaskState;
    this.useGlobalConnect = transport.useGlobalConnect;
    this.useSms = transport.useSms;
    this.usePager = transport.usePager;
    this.managementLevel = transport.managementLevel;
    this.relevance = transport.relevance;
    this.transportOptionParameterValues = transport.transportOptionParameterValues;

    this.trailerIdentifier = transport.trailerIdentifier;
    this.vehicleTypeDictionaryKey = transport.vehicleTypeDictionaryKey;
    this.loadingTypeDictionaryKey = transport.loadingTypeDictionaryKey;

    this.currentPositionIfsStatus1 = transport.currentPositionIfsStatus1;
    this.currentPositionIfsStatus2 = transport.currentPositionIfsStatus2;

    this.hasMovementOrder = transport.hasMovementOrder;
  }

}

